import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.900391 6.99844C0.900391 10.3674 3.63145 13.0984 7.00039 13.0984C10.3693 13.0984 13.1004 10.3674 13.1004 6.99844C13.1004 3.6295 10.3693 0.898438 7.00039 0.898438C3.63145 0.898438 0.900391 3.6295 0.900391 6.99844Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
